import { FC } from 'react';
import { RouterLink } from '../../../components/Button';
import { Notification } from '../../../components/Notification';
import { UUID } from '../../../types';
import styles from './InspectionNotification.module.css';
import { FormattedMessage } from 'react-intl';

interface InspectionNotificationProps {
  id: UUID;
  title: string;
}

export const InspectionNotification: FC<InspectionNotificationProps> = ({
  id,
  title,
}) => {
  return (
    <Notification>
      <div className={styles.content}>
        <div>
          <FormattedMessage id="Fill.Report" />: <br />
          <u>{title}</u>
        </div>
        <RouterLink to={`/inspection/${id}`} variant="text">
          <FormattedMessage id="StartNow" />
        </RouterLink>
      </div>
    </Notification>
  );
};
